<template>
  <span
    ref="tokenContainer"
    class="m-b-8 rtb-popover-container"
  >
    <button
      id="tokenButton"
      ref="tokenButton"
      data-cy="token-button"
      class="btn btn-secondary btn-sm"
      type="button"
      @click="toggleMacrosPopover"
    >
      Token
    </button>
    <popover
      v-model="showMacrosPopover"
      custom-class="breakdown-legend__popover"
      placement="bottom"
      trigger="manual"
      target="#tokenButton"
      @show="tagsPopoverVisible = true"
      @hide="tagsPopoverVisible = false"
    >
      <template slot="popover">
        <MacroSelectionPopover
          :focus-dropdown="tagsPopoverVisible"
          :trigger-element="$refs.tokenButton"
          :macros="macros"
          @blur="showMacrosPopover = false"
          @selected-tag="onSelectedTag"
        />
      </template>
    </popover>
  </span>
</template>

<script>
import {mapState} from 'vuex';
import MacroSelectionPopover from '@/core/components/MacroSelectionPopover';

export default {
  components: {MacroSelectionPopover},
  data() {
    return {
      tagsPopoverVisible: false,
      showMacrosPopover: false,
    };
  },
  computed: {
    ...mapState('dynamicInboundCalls', ['macros'])
  },
  methods: {
    toggleMacrosPopover() {
      this.showMacrosPopover = !this.showMacrosPopover;
      return;
    },
    onSelectedTag(tag) {
      this.showMacrosPopover = false;
      this.$emit('selected-macro', tag);
    }
  }
};
</script>

<style scoped>
.rtb-popover-container{
  display: flex;
}
</style>